export default __webpack_public_path__ + "static/media/2079.61e90303.png";